import Vue from 'vue';
import Vuex from 'vuex';
import lowCodeStore from './modules/lowCode.js'
Vue.use(Vuex);
const store = new Vuex.Store(
	{
		modules: { // 挂载子仓库
			lowCodeStore
		}
	}
);

export default store;